
import React, { useState } from 'react';
import styles from '../../../../styles/modules/ParticipantFee.module.css';
import { AiFillDollarCircle, AiTwotoneDelete } from "react-icons/ai";
import { MdDelete, MdDeleteOutline, MdModeEditOutline, MdOutlineModeEditOutline } from "react-icons/md";
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI';
import { Menu, MenuItem } from '@mui/material';
import { CiMenuKebab } from 'react-icons/ci';
import CustomCheckbox from '../../../CustomComponents/CustomCheckbox/CustomCheckbox.jsx'
import { Privileges } from '../../../../util/PrivilegeConstants.js';
const ParticipantFeeCard = ({ participantFee, handleOpenEditPopup, handleSelectParticipantFee, selectedParticipantFee, deleteParticipantFee, isOverview = false, privileges, formtemplateStatus }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionMenuClose = () => {
        setAnchorEl(null);
    };
    return (
        <div className={styles['participant_fee_card']}>
            <CustomCheckbox checked={selectedParticipantFee?.some(item=>item?.id===participantFee?.id)} onChange={(event)=>handleSelectParticipantFee(participantFee,event.target.checked)} />
            <div className={styles['participant_fee_card_details']}>
                <h2>{participantFee?.criteria}</h2>
                <p>{participantFee?.description}</p>
            </div>
            <h2 className={styles['participant_fee_card_fee']}>
                <AiFillDollarCircle className={styles['participant_fee_card_dollar_icon']} />{Number(participantFee?.feeAmount)?.toFixed(2)}
            </h2>
            {(privileges?.MANAGE_PARTICIPANT_FEE?.includes(Privileges.MODIFY) && formtemplateStatus === 'IN_PROGRESS') &&
                <div className={styles['participant_fee_card_menu']}>
                {!isOverview &&
                    <CiMenuKebab onClick={(e) => setAnchorEl(e.currentTarget)} className={styles['participan_fee_menu_icon']} />}
            </div>}


            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleActionMenuClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => {
                    handleOpenEditPopup(participantFee);
                    handleActionMenuClose();
                }
                }><MdOutlineModeEditOutline className={styles['cus_form_fields_edit_icon']} />Edit</MenuItem>
                <MenuItem onClick={() => {
                    deleteParticipantFee(participantFee.id);
                    handleActionMenuClose();
                }
                }><MdDeleteOutline className={styles['cus_form_fields_edit_icon']} />Delete</MenuItem>
            </Menu>
        </div>
    )
}

export default ParticipantFeeCard
